import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import SweetAlert from 'react-bootstrap-sweetalert';
import api from '../../../services/api';
import { Container, Table, Paginate } from './styles';
import ReactPaginate from 'react-paginate';
import Input from '../../../components/Input';
import Button from '../../../components/Button';
import Loading from '../../../components/Loading';

export default class PendingPromoters extends Component {
  state = {
    alert: {},
    loading: true,
    currentPage: 1,
    promoters: [],
    total_pages: 0,
    showAlert: false,
  };

  genreTranslation = {
    male: 'Masculino',
    female: 'Feminino',
  };

  componentDidMount() {
    this.loadPromoters();
  }

  loadPromoters = async (page = 1) => {
    try {
      const { data } = await api.get('admin/promoters', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
        params: {
          approval_status: 'pending',
          is_complete: 1,
          results: 30,
          status: 'active',
          page,
        },
      });

      data.promoters = data.promoters.map(promoter => ({
        ...promoter,
        genre: this.genreTranslation[promoter.genre],
      }));
      this.setState({ promoters: data.promoters, total_pages: data.total_pages, });

      this.setState({ loading: false });
    } catch (err) {
      this.setState({ promoters: [] });
    }
  };

  rejectPromoter = async id => {
    const { promoters } = this.state;
    const formData = new FormData();
    formData.append('approval_status', 'rejected');
    try {
      await api.put(`admin/promoters/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
      });

      this.setState({
        promoters: promoters.filter(promoter => promoter.id !== id),
      });
    } catch (err) {
      const messages = err.response
        ? err.response.data.errors
        : [
            'Não foi possível rejeitar o divulgador. Por favor, atualize a página.',
          ];
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  approvePromoter = async ({ id, city }) => {
    const { promoters } = this.state;
    const formData = new FormData();
    formData.append('engagement', this.state[`engagement-${id}`]);
    formData.append('followers', this.state[`followers-${id}`]);
    formData.append('approval_status', 'approved');
    if (!city) formData.append('city', this.state[`city-${id}`]);

    try {
      await api.put(`admin/promoters/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
      });
      await api.post(`admin/promoters/${id}/approve`, null, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
      });

      this.setState({
        promoters: promoters.filter(promoter => promoter.id !== id),
      });
    } catch (err) {
      const messages = err.response
        ? err.response.data.errors
        : [
            'Não foi possível aprovar o divulgador. Por favor, atualize a página.',
          ];
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };
  handlePageClick = (data) => {
    this.loadPromoters(data.selected + 1);
  };


  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    const {
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      loading,
      promoters,
      total_pages,
      currentPage,
      showAlert,
    } = this.state;

    return (
      <Fragment>
        {loading ? (
          <Loading />
        ) : (
          <Container>
            <h1 className="page-title">
              Divulgadores pendentes {promoters && ` (${promoters.length})`}
            </h1>
            <div className="box">
              <div className="row">
                <div className="col-12">
                  {promoters.length > 0 ? (
                    <div className="table-wrapper">
                      <Table className="table">
                        <thead>
                          <tr>
                            <th>Foto</th>
                            <th>Nome</th>
                            <th>Gênero</th>
                            <th>Cidade</th>
                            <th>Instagram</th>
                            <th>Nº de seguidores</th>
                            <th>Engajamento</th>
                            <th>Aprovar</th>
                            <th>Rejeitar</th>
                          </tr>
                        </thead>
                        <tbody>
                          {promoters.map(promoter => (
                            <tr key={promoter.id}>
                              <td>
                                <div
                                  className="profile-image"
                                  style={
                                    promoter.avatar.url && {
                                      backgroundImage: `url(${promoter.avatar.url})`,
                                    }
                                  }
                                />
                              </td>
                              <td>{promoter.name}</td>
                              <td>{promoter.id}</td>
                              <td>
                                {promoter.city ? (
                                  promoter.city
                                ) : (
                                  <Input
                                    name={`city-${promoter.id}`}
                                    value={this.state[`city-${promoter.id}`]}
                                    onChange={this.handleChange}
                                  />
                                )}
                              </td>
                              <td>
                                <a
                                  href={`http://instagram.com/${promoter.instagram_username}`}
                                  target="blank"
                                >
                                  @{promoter.instagram_username}
                                </a>
                              </td>
                              <td>
                                <Input
                                  name={`followers-${promoter.id}`}
                                  value={this.state[`followers-${promoter.id}`]}
                                  onChange={this.handleChange}
                                />
                              </td>
                              <td>
                                <Input
                                  name={`engagement-${promoter.id}`}
                                  value={
                                    this.state[`engagement-${promoter.id}`]
                                  }
                                  onChange={this.handleChange}
                                />
                              </td>
                              <td>
                                <Button
                                  onClick={() => this.approvePromoter(promoter)}
                                  className="btn-success btn-small"
                                >
                                  <FontAwesomeIcon icon={faCheck} />
                                </Button>
                              </td>
                              <td>
                                <Button
                                  onClick={() =>
                                    this.rejectPromoter(promoter.id)
                                  }
                                  className="btn-outline-secondary btn-small"
                                >
                                  <FontAwesomeIcon icon={faTimes} />
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <h5 className="text-center">
                      Não existem divulgadores pendentes.
                    </h5>
                  )}
                </div>
                <Paginate>
                        <ReactPaginate
                          previousLabel="Anterior"
                          nextLabel="Próximo"
                          breakLabel="..."
                          breakClassName="break-me"
                          pageCount={total_pages}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          onPageChange={this.handlePageClick}
                          containerClassName="pagination"
                          subContainerClassName="pages pagination"
                          activeClassName="active"
                          forcePage={currentPage}
                        />
                      </Paginate>
              </div>
            </div>
            {showAlert && (
              <SweetAlert
                type={type}
                confirmBtnText={confirmBtnText}
                confirmBtnBsStyle={confirmBtnBsStyle}
                showCancel={showCancel}
                cancelBtnText={cancelBtnText}
                cancelBtnBsStyle={cancelBtnBsStyle}
                title={title}
                onConfirm={onConfirm}
                onCancel={this.closeAlert}
              >
                <ul>
                  {messages.map(msg => (
                    <li key={msg}>{msg}</li>
                  ))}
                </ul>
              </SweetAlert>
            )}
          </Container>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/pages/PendingPromoters/index.js